// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Notifications from 'vue-notification'
import VModal from 'vue-js-modal'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/de'
// import Vuelidate from 'vuelidate'
// import socketio from 'socket.io'
// import VueSocketIO from 'vue-socket.io'
// export const SocketInstance = socketio('http://localhost:44544')
// Vue.use(VueSocketIO, SocketInstance)
// import VueSocketio from 'vue-socket.io'
import VueI18n from 'vue-i18n'
import messages from './locale'

Vue.use(VueI18n)
Vue.use(VueLodash, lodash)
Vue.use(ElementUI, {locale})
// Vue.use(Vuelidate)
// Vue.use(VueSocketio, 'http://127.0.0.1:44544')

Vue.config.productionTip = false

Vue.use(Notifications)
Vue.use(VModal)

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js